exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner--container{position:fixed;height:50px;background-color:#2d67cb;color:#fff;font-weight:600;display:flex;align-items:center;justify-content:center;width:250px;transform:rotate(-45deg);top:25px;left:-75px;z-index:999}.banner--container:hover{opacity:.3}", ""]);

// exports
